import { render } from "./CollectionApeTrait.vue?vue&type=template&id=bb16c218"
import script from "./CollectionApeTrait.vue?vue&type=script&lang=js"
export * from "./CollectionApeTrait.vue?vue&type=script&lang=js"

import "./CollectionApeTrait.vue?vue&type=style&index=0&id=bb16c218&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__